import React from 'react';
import DawaAutocomplete from '@/components/dawa/DawaAutocomplete';
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const CreateBuildingDialog = ({
  open,
  onClose,
  account,
  triggerGetLocation,
  handleCreateBuilding,
}) => {
  const [formState, setFormState] = React.useState({
    Name: '',
    AccountId: 0,
    BaselineDayInterval: 10,
    BaselineDayOffset: 'PT12H',
    AllowSaturdayBaselineDay: true,
    Location: {
      Address: '',
      Latitude: null,
      Longitude: null,
    },
    UserInput: {
      CO2Coefficients: {
        Electricity: [],
        Heat: [],
        Gas: [],
      },
    },
  });

  const handleSubmit = () => {
    if (formState.Name && formState.Location.Address) {
      handleCreateBuilding(formState);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Create new Building on account: {account?.Name}</DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Navn"
          value={formState.Name}
          required
          error={!formState.Name}
          onChange={(e) =>
            setFormState((prev) => ({
              ...prev,
              Name: e.target.value,
            }))
          }
          fullWidth
          variant="filled"
          helperText="Provide a name for the building"
        />
        <DawaAutocomplete
          onLocationSelect={async (location) => {
            if (location && location.data) {
              try {
                const result = await triggerGetLocation(
                  location.data.id,
                ).unwrap();

                if (result) {
                  setFormState((prev) => ({
                    ...prev,
                    Location: {
                      Address: result.adgangsadresse.adressebetegnelse || '',
                      Latitude:
                        result.adgangsadresse.adgangspunkt.koordinater[1],
                      Longitude:
                        result.adgangsadresse.adgangspunkt.koordinater[0],
                    },
                  }));
                }
              } catch (error) {
                console.error('Error fetching location data:', error);
              }
            }
          }}
          value={formState.address || ''}
          placeholder="Vælg adresse"
          disableField={false}
        />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            required
            type="number"
            name="BaselineDayInterval"
            label="Baseline Day Interval"
            size="small"
            fullWidth
            variant="filled"
            value={formState.BaselineDayInterval}
            helperText="Interval in days for baseline calculation"
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayInterval: e.target.value,
              }))
            }
          />
          <TextField
            required
            name="BaselineDayOffset"
            label="Baseline Day Offset"
            size="small"
            variant="filled"
            fullWidth
            value={formState.BaselineDayOffset}
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayOffset: e.target.value,
              }))
            }
            helperText="Offset in days for the baseline day calculation"
            // type="number"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            // Handle form submission logic here
            handleSubmit();
            onClose();
          }}
          variant="contained"
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateBuildingDialog;
